Ext.define('SA.NumberField2', {
    alias: 'widget.number-field-2',
    extend: 'Ext.Component',

    baseCls: 'sa-number-field-2',
    html: '<input type="number" step="any">',

    afterRender() {
        this.callParent();

        this.input = this.el.dom.querySelector('input');
    },

    getValue() {
        return this.input.value;
    },

    initEvents() {
        this.callParent();

        this.input.addEventListener('change', this.onChange.bind(this));
        this.input.addEventListener('keydown', this.onKeyDown.bind(this));
        this.input.addEventListener('beforeinput', this.onBeforeInput.bind(this));
    },

    onBeforeInput(ev) {
        if (/[+eE]/.test(ev.data)) {
            ev.preventDefault();
        }
    },

    onChange() {
        this.fireEvent('change');
    },

    onKeyDown(ev) {
        if (['ArrowUp', 'ArrowDown'].includes(ev.code)) {
            ev.preventDefault();
        }
    },

    setValue(value) {
        this.input.value = value;
    }
});